// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Flex_wrapper__1kICk","inner":"Flex_inner__z2K8_","item":"Flex_item__7CXlR"};